document.addEventListener('DOMContentLoaded', function () {
  let productCache = null;

  fetch(window.location.pathname.split('?')[0].replace(/\/variants\/\d+/, '') + '.js')
    .then(r => r.json())
    .then(function (product) {
      productCache = product;
    });

  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('li[data-target]');
    if (!thumb) return;

    const target = thumb.dataset.target;
    const mediaId = parseInt(target.split('-').pop());
    if (!mediaId || !productCache) return;

    const variant = productCache.variants.find(function (v) {
      return v.featured_media && v.featured_media.id === mediaId;
    });

    if (!variant) return;

    const component = document.querySelector('variant-selects') || document.querySelector('variant-radios');
    if (!component) return;

    const select = component.querySelector('select');
    if (!select) return;

    const matchingOpt = Array.from(select.options).find(o => o.value === variant.option1);
    if (!matchingOpt || !matchingOpt.dataset.optionValueId) return;

    const productUrl = '/products/' + productCache.handle;

    // Set productUrl on the option so ProductInfo builds the right fetch URL
    matchingOpt.dataset.productUrl = productUrl;

    // Update selected attribute so selectedOptionValues getter returns correct ID
    Array.from(select.options).forEach(opt => opt.removeAttribute('selected'));
    matchingOpt.setAttribute('selected', 'selected');
    select.value = variant.option1;

    // Temporarily suppress VariantSelects' updateSelectionMetadata
    // to prevent it from interfering, then restore it after
    const originalUpdate = component.updateSelectionMetadata.bind(component);
    component.updateSelectionMetadata = function() {};

    // Dispatch real change event from the select — event.target will be
    // the select element, which IS inside product-info, so contains() passes
    select.dispatchEvent(new Event('change', { bubbles: true }));

    // Restore after event has been processed
    requestAnimationFrame(function() {
      component.updateSelectionMetadata = originalUpdate;
    });
  });
});
